import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
  faShoppingCart,
  faTags
} from "@fortawesome/free-solid-svg-icons";

export const InCartButton = () => {
  return (
    <Button id="inCartButton" color="primary" outline size="sm" disabled>
      <FontAwesomeIcon icon={faShoppingCart} className="me-2" />
      <span>In Cart</span>
    </Button>
  );
};

export const AddToCartButton = ({ onCartAdd, sku, id, price, setAdded }) => {
  return (
    <Button
      id="addToCartButton"
      color="primary"
      size="sm"
      onClick={() => {
        onCartAdd(sku, id, price);
        setAdded(true);
      }}
    >
      <FontAwesomeIcon icon={faCartPlus} className="me-2" />
      <span>Add to Cart</span>
    </Button>
  );
};

AddToCartButton.propTypes = {
  onCartAdd: PropTypes.func.isRequired,
  setAdded: PropTypes.func.isRequired,
  sku: PropTypes.string,
  id: PropTypes.number,
  price: PropTypes.number
};

AddToCartButton.defaultProps = {
  sku: null,
  id: null,
  price: null
};

export const GetQuoteButton = ({ name, sku }) => {
  return (
    <a
      className="get-quote"
      href={`/request-pricing/name=${name}sku=${sku}`}
      rel="origin-when-cross-origin"
    >
      <FontAwesomeIcon icon={faTags} alt="tags icon" />
      Request an Enterprise Quote
    </a>
  );
};

GetQuoteButton.propTypes = {
  name: PropTypes.string,
  sku: PropTypes.string
};

GetQuoteButton.defaultProps = {
  name: null,
  sku: null
};
